module.exports = __webpack_public_path__ + "static/img/popup-bg.4054741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/popup-bg.png
// module id = Vsqu
// module chunks = 1